<template>
  <div :class="[$style.notification, $style.activityNotLogged]">
    <div :class="$style.main">
      <a
        :href="formatUrl(notification.url)"
        :class="$style.header"
        :target="linkTarget"
      >
        <img
          :src="photoUrl(notification.prospect.photoUrl)"
          :title="notification.prospect.name"
          alt=""
        />
        <i class="fa fa-thumbs-up"></i>
        <span>{{ notification.title }}</span>
      </a>
      <span :class="$style.timer">{{ timer }}</span>
    </div>
    <a
      @click.prevent="readNotification(notification)"
      href="#"
      :class="$style.markAsRead"
      data-toggle="tooltip"
      data-placement="left"
      title="mark as read"
    >
      <font-awesome-icon :icon="faTrashAlt" />
    </a>
  </div>
</template>

<script>
import Notification from "./notification";

export default {
  mixins: [Notification],
  methods: {
    formatUrl(url) {
      // url is a hash
      // e.g. #activity-summary?activityId=6f72cd6c-0516-4089-934c-69ccf980c90a
      return `${this.$_notifications_config.jiminnyHost()}${url}&nId=${
        this.notification.id
      }`;
    },
  },
};
</script>

<style module lang="less" src="./notification.less"></style>



// WEBPACK FOOTER //
// activity-not-logged.vue?f3362f4a